"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
const lodash_1 = require("lodash");
class XucThirdPartyService {
    constructor($rootScope, $http, $q, $window, XucPhoneEventListener, XucUser, XucQueue, XucAgent, XucLink, $log) {
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$q = $q;
        this.$window = $window;
        this.XucPhoneEventListener = XucPhoneEventListener;
        this.XucUser = XucUser;
        this.XucQueue = XucQueue;
        this.XucAgent = XucAgent;
        this.XucLink = XucLink;
        this.$log = $log;
        this._actionEventName = 'XucThirdParty.Action';
        this._clearEventName = 'XucThirdParty.Clear';
        this._thirdPartyActions = [];
        this._wasEstablished = false;
        this._$log = $log;
        this._$log.debug('XucThirdParty service initialization');
        this.XucPhoneEventListener.addRingingHandler(this.$rootScope, this._onRinging.bind(this));
        this.XucPhoneEventListener.addEstablishedHandler(this.$rootScope, this._onEstablished.bind(this));
        this.XucPhoneEventListener.addReleasedHandler(this.$rootScope, this._onReleased.bind(this));
    }
    setThirdPartyWs(url) {
        this._thirdPartyWs = url;
    }
    ;
    addActionHandler(scope, callback) {
        let handler = this.$rootScope.$on(this._actionEventName, function (event, action) {
            callback(action);
        });
        scope.$on('$destroy', handler);
    }
    ;
    addClearHandler(scope, callback) {
        let handler = this.$rootScope.$on(this._clearEventName, callback);
        scope.$on('$destroy', handler);
    }
    ;
    clearAllActions() {
        for (let action of this._thirdPartyActions) {
            if (action.autopause) {
                this.XucAgent.unpause();
                break;
            }
        }
        this.$rootScope.$emit(this._clearEventName);
        this._thirdPartyActions = [];
    }
    ;
    _callThirdPartyWs(data) {
        if (!this._thirdPartyWs) {
            let defer = this.$q.defer();
            defer.reject("XucThirdParty not initialized with WS Url");
            return defer.promise;
        }
        return this.$http.post(this._thirdPartyWs, JSON.stringify(data))
            .then((response) => {
            this._$log.debug(`Got WS Response ${JSON.stringify(response.data)}`);
            this._thirdPartyActions.push(response.data);
        }, () => {
            this._$log.error(`Error while fetching response from ${this._thirdPartyWs}`);
        });
    }
    ;
    _checkAndFireEvent(phoneEvent) {
        if (this._thirdPartyActions.length > 0) {
            if (phoneEvent === "EventEstablished") {
                this._wasEstablished = true;
            }
            this._thirdPartyActions.forEach(action => {
                if (phoneEvent === action.event && !action.triggered) {
                    if (phoneEvent !== "EventReleased" || (phoneEvent === "EventReleased" && this._wasEstablished)) {
                        this._$log.debug("Firing ThirdParty action");
                        if (action.autopause) {
                            if (angular_1.default.isDefined(action.autopauseReason)) {
                                this.XucAgent.pauseWithReason(action.autopauseReason);
                            }
                            else {
                                this.XucAgent.pause();
                            }
                        }
                        this.$rootScope.$emit(this._actionEventName, angular_1.default.copy(action));
                        action.triggered = true;
                    }
                }
            });
        }
    }
    ;
    _onRinging(event) {
        this._$log.debug(`_onRinging ${JSON.stringify(event)}`);
        let promises = [this.XucUser.getUserAsync(), this.XucLink.whenLogged()];
        if (typeof (event.queueName) !== "undefined") {
            promises.push(this.XucQueue.getQueueByNameAsync(event.queueName));
        }
        this._wasEstablished = false;
        this.$q.all(promises).then((results) => {
            let user = results[0];
            let queue;
            let token = results[1].token;
            if (results.length > 2) {
                queue = results[2];
            }
            let data = {
                user: {
                    userId: user.userId,
                    agentId: user.agentId,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    fullName: user.fullName,
                    token: token
                },
                callee: event.DN,
                caller: event.otherDN,
                userData: event.userData,
                callDataCallId: event.linkedId,
                queue: typeof (queue) !== "undefined" ? {
                    id: queue.id,
                    name: queue.name,
                    displayName: queue.displayName,
                    number: queue.number
                } : undefined
            };
            if (typeof (queue) === "undefined") {
                delete data['queue'];
            }
            this._callThirdPartyWs(data)
                .then(() => {
                this._checkAndFireEvent(this.XucPhoneEventListener.EVENT_RINGING);
            })
                .catch(() => {
                this._$log.debug("Service seems disabled or not available");
            });
        });
    }
    ;
    _onEstablished(event) {
        this._$log.debug("_onEstablished");
        this._checkAndFireEvent(event.eventType);
    }
    ;
    _sendCountDownEvent() {
        if (!(0, lodash_1.isNil)(document.getElementById('thirdpartyframe'))) {
            this._thirdPartyActions.forEach(action => {
                document.getElementById('thirdpartyframe').contentWindow.postMessage('xivo-StartCountDown', action ? action.url : "");
            });
        }
    }
    ;
    _onReleased(event) {
        this._$log.debug("_onReleased");
        this._checkAndFireEvent(event.eventType);
        this._sendCountDownEvent();
        this._thirdPartyActions = this._thirdPartyActions.filter(action => action.triggered);
    }
    ;
}
exports.default = XucThirdPartyService;
XucThirdPartyService.$inject = ["$rootScope", "$http", "$q", "$window", "XucPhoneEventListener", "XucUser", "XucQueue", "XucAgent", "XucLink", "$log"];
